import styled from 'styled-components';

const AppContainer = styled.div`
  max-width: ${({ small, theme }) =>
    small ? theme.smallWidth : theme.maxWidth}px;
  margin: auto;
`;

export default AppContainer;
